/* jshint undef: true, unused: true */
/* globals txt */

var notJquery = require('../../../../js_functions/form-builder/js/not-jquery');
var nJ = notJquery;

const visibleFields = require('./equipment-visible-client-fields')();

module.exports = function formBuilderStructure() {
  // Field Definitions
  var topRow = {
        answersId : {
          page        : 0,
          elementType : 'hidden',
          attributes  : {
            name : 'answersId'
          }
        },
        columnTopEmptyRow: {
          page: 0,
          elementType: 'multicolumn',
          wrapperClass: ['column-top-row', 'grid-row'],
          attributes: {
            id: 'column-title-row',
            name: 'column-title-row'
          },
          inputChildren: {
            emptyColumn: {
              nonFormElement: true,
              elementType: 'span',
              wrapperClass: 'col-12',
              attributes: {}
            }
          }
        }
      },
      bottomRow = {
        editBottomRow: {
          page: 0,
          elementType: 'multicolumn',
          wrapperClass: ['grid-row', 'grid-row-border-top'],
          attributes: {
            id: 'button-bottom-row',
            name: 'button-bottom-row'
          },
          inputChildren: {
            deleteRowBottom: {
              elementType: 'button',
              wrapperClass: 'col-4',
              onClick: 'deleteButtonAction',
              attributes: {
                id: 'delete-row-bottom',
                name: 'delete-row-bottom',
                class: ['dtx-button', 'dtx-button-small', 'button-warning'],
                html: 'DEVICES.V2.DISPLAY.BUTTON.DELETE',
                type: 'button'
              }
            },
            emptyColumn: {
              nonFormElement: true,
              elementType: 'span',
              wrapperClass: ['col-4', 'edit-row-bottom-message'],
              attributes: {
                html: txt.equipment_editing_disabled
              }
            },
            editRowBottom: {
              elementType: 'button',
              wrapperClass: 'col-4',
              onClick: 'createNewEditForm',
              attributes: {
                id: 'edit-row-bottom',
                name: 'edit-row-bottom',
                class: ['dtx-button', 'dtx-button-small', 'button-secondary', 'cmt__button--edit-form'],
                html: 'DEVICES.V2.DISPLAY.BUTTON.EDIT_DEVICES',
                type: 'button'
              }
            }
          }
        }
      },
      defaultInputTypes = {
        // Core: Always display these fields.
        // Assume ids should be hardcoded for now.
        // Ids can be strings.
        // Make a list of core fields which are automatically decorated.
        brandName: {
          label: 'DEVICES.V2.DISPLAY.LABEL.BRAND_NAME',
        },
        type: {
          label: 'DEVICES.V2.DISPLAY.LABEL.TYPE',
          populatedBy: 'brandName',
          graphQLID: 0
        },
        subType: {
          label: 'DEVICES.V2.DISPLAY.LABEL.SUB_TYPE',
          populatedBy: 'brandName',
          graphQLID: 0
        },
        productName: {
          // GenericName
          label: 'DEVICES.V2.DISPLAY.LABEL.PRODUCT_NAME',
          populatedBy: 'brandName',
          graphQLID: 0
        },
        manufacturer: {
          label: 'DEVICES.V2.DISPLAY.LABEL.MANUFACTURER',
          populatedBy: 'brandName',
          graphQLID: 0
        },
        supplyCategory: {
          label       : 'DEVICES.V2.DISPLAY.LABEL.SUPPLY_CATEGORY',
          populatedBy : 'brandName'
        },
        supplyClassification: {
          label       : 'DEVICES.V2.DISPLAY.LABEL.SUPPLY_CLASSIFICATION',
          populatedBy : 'brandName'
        },
        // End of Core
        model: {
          label: 'DEVICES.V2.DISPLAY.LABEL.MODEL',
          graphQLID: 0
        },
        catalogueNumber: {
          label: 'DEVICES.V2.DISPLAY.LABEL.CATALOGUE_NUMBER',
          graphQLID: 8
        },
        batchNumber: {
          label: 'DEVICES.V2.DISPLAY.LABEL.BATCH_NUMBER',
          graphQLID: 12
        },
        quantityUsed: {
          label: 'DEVICES.V2.DISPLAY.LABEL.QUANTITY_USED',
          graphQLID: 4
        },
        expiryDate: {
          label: 'DEVICES.V2.DISPLAY.LABEL.EXPIRY_DATE',
          graphQLID: 6
        },
        dateManufactured: {
          label: 'DEVICES.V2.DISPLAY.LABEL.DATE_MANUFACTURED',
          graphQLID: 6
        },
        serialNumber: {
          label        : 'DEVICES.V2.DISPLAY.LABEL.SERIAL_NUMBER',
          visibility : globals.vanessasLawEnabled,
          graphQLID    : 7
        },
        supplier: {
          label: 'DEVICES.V2.DISPLAY.LABEL.SUPPLIER',
          graphQLID: 9
        },
        currentLocationOfDevice: {
          label: 'DEVICES.V2.DISPLAY.LABEL.CURRENT_DEVICE_LOCATION',
          graphQLID: 0
        },
        deviceType: {
          label: 'DEVICES.V2.DISPLAY.LABEL.DEVICE_TYPE'
        },
        operator: {
          label: 'DEVICES.V2.DISPLAY.LABEL.DEVICE_OPERATOR'
        },
        usage: {
          label: 'DEVICES.V2.DISPLAY.LABEL.DEVICE_USAGE'
        },
        sourceId: {
          label        : 'DEVICES.V2.DISPLAY.LABEL.DEVICE_ID',
          visibility : globals.vanessasLawEnabled,
          graphQLID    : 0
        }
      },
      defaultInputs = [
        'brandName',
        'type',
        'subType',
        'productName',
        'manufacturer',
        'model',
        'supplyCategory',
        'supplyClassification',
        'deviceType',
        'quantityUsed',
        'batchNumber',
        'expiryDate',
        'dateManufactured',
        'catalogueNumber',
        'supplier',
        'sourceId',
        'serialNumber',
        'operator',
        'usage',
        'currentLocationOfDevice'
      ].reduce(function (structureCarried, key) {

        // Set up the config structure for a field.
        var fieldStructure = nJ.deepMerge(
          {
            // Intial structure.
            elementType: 'hiddenWithText',
            labelFor: false,
            labelClass: ['col-12'],
            wrapperClass: ['grid-row', 'cmt-data-value'],
            attributes: {
              name: key,
              class: ['col-12', 'cmt-data-value', 'equipment-display-field']
            },
            visibility: visibleFields.indexOf(key) > -1
          },
          [
            [defaultInputTypes, defaultInputTypes[key]]
          ].find(function (item) {
            return item[0][key];
          })[1]
        );

        structureCarried[key] = fieldStructure;
        return structureCarried;
      }, {});

  return $.extend({}, $.extend({}, topRow, defaultInputs), bottomRow);

};
